import 'components/Blog/styles.css';
import CoverImage from 'components/cover-image';
import { Link } from 'gatsby';
import React from 'react';
import { MathJaxContext, MathJax } from 'better-react-mathjax';

export default function ({ post }) {
  const category =
    post?.category?.length > 0 ? (
      post?.category?.map((item, index) => (
        <>
          <Link className="blog-thumb-link" to={`/blog/categories/${item.slug}`}>
            {item.name}
          </Link>
          {index < post.category.length - 1 && <span style={{ margin: '0px 5px 0px 5px' }}>|</span>}
        </>
      ))
    ) : (
      <Link className="blog-thumb-link" to={`/blog/categories/uncategorized`}>
        Uncategorized
      </Link>
    );
  return (
    <MathJaxContext>
      <div className="scolumn 4">
        <div style={{ padding: '10px' }}>
          <div style={{ backgroundColor: '#fec5de' }}>
            <CoverImage title={post.title} fluid={post.coverImage.small} slug={post.slug} />
            <div
              style={{
                padding: '15px',
                display: 'flex',
                flexDirection: 'column',
                height: '365px',
              }}
            >
              <div>
                <Link className="blog-thumb-link" to={`/blog/${post.slug}`}>
                  <h3 style={{ paddingTop: '15px' }}>{post.title}</h3>
                </Link>
              </div>
              <p style={{ fontSize: '0.8rem' }}>{category}</p>
              <p style={{ fontSize: '0.9rem' }}>
                By {post.author.name} | {post.date}
              </p>
              <div
                style={{
                  flex: '1',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <MathJax hideUntilTypeset="first">
                  <p>{post.excerpt}</p>
                </MathJax>
              </div>
              <div>
                <Link className="blog-thumb-link" to={`/blog/${post.slug}`}>
                  <p style={{ marginBottom: '0px' }}>Read More...</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MathJaxContext>
  );
}
